export default {
  getlogoUploadPercentage(state) {
    return state.logoUploadPercentage;
  }
};
